var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',{staticStyle:{"width":"100%"},attrs:{"value":_vm.value,"options":_vm.options,"props":{ checkStrictly: true },"clearable":""},on:{"change":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }